import { AppData } from '@scts/app-data';
import { Accessibility } from '@scts-ui/component-library';

const AccessibilityComponent = () => {
  return (
    <Accessibility
      contactEmail={AppData.accessibility.contactEmail}
      complianceIssues={AppData.accessibility.complianceIssues}
      datePrepared={'29 May 2023'}
    />
  );
};

export default AccessibilityComponent;
